import React, { useState, useEffect } from 'react'
import * as yup from "yup";
import moment from 'moment';
import PlacesAutocomplete, { geocodeByAddress, geocodebyPlaceId, getLatLng } from 'react-places-autocomplete'
// import { userSchema } from '../../Validations/UserValidation';
import useLocalStorage from "uselocalstorage-react-hook";
import StyledJoinClubHeader from './JoinClubHeader.styles';
import StyledFormStep from './StyledFormStep.styles';
import styled from 'styled-components';
import Map from '../Map/Map';
import ItemCard from '../ItemCard/ItemCard';
import VideoWelcome from '../VideoWelcome/VideoWelcome';
import PayFailWelcome from '../PayFailWelcome/PayFailWelcome';
import LoadingSpinner from '../LoadingSpinner';
import DotsLoadingSpinner from '../DotsLoadingSpinner';




const StyledModal = styled.div`
form label {
 font-size: 0.78em;
 font-weight: normal;
 filter: drop-shadow(1px 2px 2px rgba(0,0,0,0.08));
 /* transform: scaleY(1.32); */
 letter-spacing: 0.05;
 position: block !important;
 top: -0.88em;
 right: 0;
 bottom: 0;
 left: -0.67em;
 padding-left: 5px;
 color: #222;
}
.dabody {
 /* font-family: "Inter", sans-serif; */
 line-height: 1.5;
 min-height: 100vh;
 display: flex;
 align-items: center;
 justify-content: center;
 background-color: #f8f8f9;
}

.checkbox-group {height:auto}

.checkbox-group {
 display: flex;
 flex-wrap: wrap;
 justify-content: center;
 width: 90%;
 margin-left: auto;
 margin-right: auto;
 max-width: 600px;
 border: 1px solid rgba(0,0,0,0.67);
 -webkit-user-select: none;
 -moz-user-select: none;
 -ms-user-select: none;
 user-select: none;
}
.checkbox-group > * {
 margin: 0.5rem 0.5rem;
}

.checkbox-group-legend {
 font-size: 1rem;
 font-weight: 700;
 color: #9c9c9c;
 text-align: center;
 line-height: 1.125;
 margin-bottom: 1.25rem;
}

.checkbox-input {
 clip: rect(0 0 0 0);
 -webkit-clip-path: inset(100%);
 clip-path: inset(100%);
 height: 1px;
 overflow: hidden;
 position: absolute;
 white-space: nowrap;
 width: 1px;
}
.checkbox-input:checked + .checkbox-tile {
 border-color: #9c7456;
 box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
 color: #906010;
}
.checkbox-input:checked + .checkbox-tile:before {
 transform: scale(1);
 opacity: 1;
 background-color: #bada55;
 border-color: #9c7456;
}
.checkbox-input:checked + .checkbox-tile .checkbox-icon, .checkbox-input:checked + .checkbox-tile .checkbox-label {
 color: #9c7456;
}
.checkbox-input:focus + .checkbox-tile {
 border-color: #9c7456;
 box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1), 0 0 0 4px #b5c9fc;
}
.checkbox-input:focus + .checkbox-tile:before {
 transform: scale(1);
 opacity: 1;
}

.checkbox-tile {
 display: flex;
 flex-direction: column;
 align-items: center;
 justify-content: center;
 width: 7rem;
 min-height: 7rem;
 border-radius: 0.5rem;
 border: 2px solid #9c7456;
 background-color: #fff;
 box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
 transition: 0.15s ease;
 cursor: pointer;
 position: relative;
}
.checkbox-tile:before {
 content: "";
 position: absolute;
 display: block;
 width: 1.25rem;
 height: 1.25rem;
 border: 2px solid #b5bfd9;
 background-color: #fff;
 border-radius: 50%;
 top: 0.25rem;
 left: 0.25rem;
 opacity: 0;
 transform: scale(0);
 transition: 0.25s ease;
 background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='192' height='192' fill='%23FFFFFF' viewBox='0 0 256 256'%3E%3Crect width='256' height='256' fill='none'%3E%3C/rect%3E%3Cpolyline points='216 72.005 104 184 48 128.005' fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-width='32'%3E%3C/polyline%3E%3C/svg%3E");
 background-size: 12px;
 background-repeat: no-repeat;
 background-position: 50% 50%;
}
.checkbox-tile:hover {
 border-color: #9c7456;
}
.checkbox-tile:hover:before {
 transform: scale(1);
 opacity: 1;
}

.checkbox-icon {
 transition: 0.375s ease;
 color: #494949;
}

.checkbox-icon-img {
 height: auto;
 width: 2.3em;
 padding: 5px 7px; 
}

.checkbox-label {
 color: #707070;
 transition: 0.375s ease;
 text-align: center;
}

@media screen and (min-width: 600px){
 max-width: 875px;
 zoom: 1.15;
 
}
`;

const StyledBottleNumSelect = styled.div`

 margin: -2.3em auto auto auto;

 .bottle-num-title {
 font-family: 'Bebas Neue', cursive;
 padding-left: 0.06em;
 color: #222;
 }
 .bottle-num-select {
 margin: auto;
 display: flex;
 flex-direction: row;
 flex-wrap: nowrap;
 gap: 0.67em;
 justify-content: center;
 }
 .bottle-card {
 display: flex;
 flex-direction: column;
 width: 6em;
 background: white;
 box-sizing: border-box;
 box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
 border-radius: 8px;
 /* active toggle */
 /* border: 2px solid #8C683C; */
 box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
 }
 .bottle-card:hover {
 border: 2px solid #8C683C;
 box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
 }
 .bottle-card-active {
 box-sizing: border-box;
 border: 2px solid #8C683C;
 }
 .bottle-card-img {
 height: auto;
 max-height: 8.93em;
 }
 .bottle-card-footer-box {
 display: grid;
 place-content: center;
 margin-top: 1px;
 height: 2.3em;
 border-radius: 0px 0px 6px 6px;
 zoom: 0.99;
 /* active toggle */
 background: #fff;
 /* #8C683C */
 }
 .footer-box-active {
 background: #8C683C;
 border: 2px solid #8C683C;
 }

 .bottle-card-footer-text {
 text-align: center;
 font-family: 'Bebas Neue', cursive;
 padding: 0.1em 0 0 0;
 font-weight: bold;
 text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
 filter: contrast(0.97);
 /* toggle active #fff; */
 color: #8C683C;
 }
 .footer-text-active {
 color: #fff;
 }


 @media screen and (min-width: 600px){
 max-width: 875px;
 zoom: 1.15;
}

`;

const StyledDetailsReview = styled.div`
display: flex;
flex-direction: column;
line-height: 2.3;
margin-top: -2.9em;

h5.edit-details {
 color: #8C683C;
 font-family: 'Bebas Neue', cursive;
 font-size: 1em;
 text-transform: none;
}

li { 
 /* font-family: "sans-serif"; */
 list-style: none;
 font-family: 'Roboto', sans-serif;
 text-shadow: 1px 1px 1px rgba(0,0,0,0.32);
 color: #222;
 font-size: 0.95em;
 }
 .review-detail-item {
 font-family: 'Roboto', sans-serif;
 font-weight: bold;
 font-size: 0.95em;
 letter-spacing: 0.03em;
 text-shadow: none;
}

@media screen and (min-width: 600px){
 max-width: 875px;
 zoom: 1.15;

 li { 
 /* font-family: "sans-serif"; */
 list-style: none;
 font-family: 'Roboto', sans-serif;
 /* text-shadow: 1px 1px 1px rgba(0,0,0,0.32); */
 color: #222;
 font-size: 0.85em;
 }
}
`;

const StyledSelect = styled.div`
.inputGroup {
 background-color: #fff;
 display: flex;
 margin: 10px 0;
 position: relative;
}
.inputGroup label {
 padding: 12px 30px;
 width: 100%;
 display: block;
 text-align: left;
 color: #3C454C;
 cursor: pointer;
 position: relative;
 z-index: 2;
 transition: color 200ms ease-in;
 overflow: hidden;
}
.inputGroup label:before {
 width: 10px;
 height: 10px;
 border-radius: 50%;
 content: "";
 background-color: #fff5e7;
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translate(-50%, -50%) scale3d(1, 1, 1);
 transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
 opacity: 0;
 z-index: -1;
}
.inputGroup label:after {
 width: 32px;
 height: 32px;
 content: "";
 border: 2px solid #D1D7DC;
 background-color: #fff;
 background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M5.414 11L4 12.414l5.414 5.414L20.828 6.414 19.414 5l-10 10z' fill='%23fff' fill-rule='nonzero'/%3E%3C/svg%3E ");
 background-repeat: no-repeat;
 background-position: center;
 border-radius: 50%;
 z-index: 2;
 position: absolute;
 /* right: 30px; */
 top: 50%;
 padding:0;
 text-align: center;
 transform: translateY(-50%);
 cursor: pointer;
 transition: all 200ms ease-in;
}
.inputGroup input:checked ~ label {
 color: #222;
 
}
.inputGroup input:checked ~ label:before {
 transform: translate(-50%, -50%) scale3d(56, 56, 1);
 opacity: 1;
}
.inputGroup input:checked ~ label:after {
 background-color: #9c7456;
 border-color: #9c7456;
 background-position: 0.3em 0.3em;
}
.inputGroup input {
 width: 32px;
 height: 32px;
 order: 1;
 z-index: 2;
 position: absolute;
 right: 30px;
 top: 50%;
 transform: translateY(-50%);
 cursor: pointer;
 visibility: hidden;
 margin-left: 4em;
}

.club-type {
 margin-top: -3em;
}

`;

const JoinClubHeader = () => {
  moment().format();

  
  
  // ###todo conditionally add one in handleset set active step and account for back minus one.
  const handleNextStep = (e) => { (activeStep < 5) && setActiveStep(activeStep + 1) }
  const handleBackStep = (e) => { (activeStep > 1) && setActiveStep(activeStep - 1) }
  // available steps "a"- [1,2,3] "b"-[1] "c"-[1,2] = 6 total (3) + (1) + (2)
  //  const { inputs, handleChange } = useForm({});
  const [locationsCHW, setLocationsCHW] = useState([]);
  const [isLocationSelected, setIsLocationSelected] = useState(0);
  const [restaurants, setRestaurants] = useState([]);
  const [initLat, setInitLat] = useState();
  const [initLng, setInitLng] = useState();
  const [mapRadius, setMapRadius] = useState(120);
  const [typedLat, setTypedLat] = useState();
  const [typedLng, setTypedLng] = useState();

  




  const [address, setAddress] = useState('');
  const [coordinates, setCoordinates] = useState({
    lat: null,
    lng: null
  });

  const handleSelect = async value => {
    const results = await geocodeByAddress(value);

    const ll = await getLatLng(results[0])
    console.log('ll: ', ll);
    setAddress(value);
    setCoordinates(ll);
  }

  const [selectedLat, setSelectedLat] = useState(41.9032)
  const [selectedLng, setSelectedLng] = useState(-87.6383)
  const [activeStep, setActiveStep] = useState(1);
  const [formattedTime, setFormattedTime] = useState('formattedTime');
  const [selectBottleLvl, setSelectBottleLvl] = useState(3);
  const [activeStepFormHeading, setActiveStepFormHeading] = useState('Recipient Details');
  const [isSignupCompleted, setIsSignupCompleted] = useState(false);
  const [birthDateMonth, setBirthDateMonth] = useLocalStorage('birthDateMonth', '');
  const [birthDateDay, setBirthDateDay] = useLocalStorage('birthDateDaygit', '');
  const [birthDateYear, setBirthDateYear] = useLocalStorage('birthDateYear', '');
  const [memberAge, setMemberAge] = useState();
  const [monthlyMembership, setMonthlyMembership] = useState(true);
  const [giftMembership, setGiftMembership] = useState(false);
  const [isDelivery, setIsDelivery] = useState(false);
  const [locationSelectedName, setLocationSelectedName] = useState('Location');
  const [locationSelectedAddress, setLocationSelectedAddress] = useState('Location Address');
  const [locationSelectedCity, setLocationSelectedCity] = useState('Location City');
  const [clubType, setClubType] = useLocalStorage("clubType", "");
  const [subscriptionLength, setSubscriptionLength] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [altBack, setAltBack] = useState(false);
  const [emailAddress, setEmailAddress] = useLocalStorage("emailAddress", "");
  const [paymentSuccess, setPaymentSuccess] = useState();
  const [chwBluePayAmount, setChwBluePayAmount] = useState(19.99);
  const [userInfoSavingSFLoading, setUserInfoSavingSFLoading] = useState(false)
  const [blueFormLoading, setBlueFormLoading] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [userPassword, setUserPassword] = useState('')
  const [passwordShow, setPasswordShow] = useState(false)
  const [phoneNumber, setPhoneNumber] = useState('')

  const [recipFirstName, setRecipFirstName] = useState('')
  const [recipLastName, setRecipLastName] = useState('')
  const [recipEmail, setRecipEmail] = useState('')
  const [recipMessage, setRecipMessage] = useState('')

  
  const [emailValid, setEmailValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [bdayValid, setBdayValid] = useState(false);
  const [step1Complete, setStep1Complete] = useState(false);
  const [step1ErrorMessage, setStep1ErrorMessage] = useState('');
  const [step3Complete, setStep3Complete] = useState(false);
  const [step4Complete, setStep4Complete] = useState(false);



  const [bluepayUrl, setBluepayUrl] = useState(`https://secure.bluepay.com/interfaces/shpf?SHPF_FORM_ID=CHWF10&SHPF_ACCOUNT_ID=100067019970&MODE=TEST&AMOUNT=${chwBluePayAmount}&SHPF_TPS_DEF=SHPF_FORM_ID+SHPF_ACCOUNT_ID+MODE+AMOUNT&SHPF_TPS=580a3b37dce6ac44036075c763efba93&MERCHANT=100067019970&TRANSACTION_TYPE=SALE&F_TRANSARMOR=2&TAMPER_PROOF_SEAL=f9c0c9237c64f7439347fb9b31bee748&REDIRECT_URL=https://localhost/apex/CHW_BluePayProcess&RESPONSEVERSION=999&CUSTOM_ID=WCMFEE&CUSTOM_ID2=00341000018s6wdAAA&NAME1=${firstName}&NAME2=${lastName}&EMAIL=lownsj%40comcast.net&ADDR1=319+6th+St&CITY=Downers+Grove&STATE=Illinois&ZIPCODE=60515&PHONE=(630)+363-0246&COMMENT=LID:a0h410000046VJP::SC:1::MTCID:::MWOMTEMP:::`);



  useEffect(() => {
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };

    function success(pos) {
      var crd = pos.coords;


      setInitLat(crd.latitude);
      setInitLng(crd.longitude);
      // setSelectedLat(crd.latitude);
      // setSelectedLng(crd.longitude);
      console.log(`More or less ${crd.accuracy} meters.`);
      console.log('first,crd', crd)

    }

    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }
    navigator.geolocation.getCurrentPosition(success, error, options);

  }, [])

  // validate each step of form
  const checkStep1Completed = () => {
    
    // check if step one birthday is valid
    if (birthDateMonth.length === 2 && birthDateDay.length === 2 && birthDateYear.length === 4) {
      var yearsOld = moment().diff(`${birthDateMonth}/${birthDateDay}/${birthDateYear}`, 'years',false);
      if(yearsOld >= 21){setStep1Complete(true);setStep1ErrorMessage('')}else{setStep1ErrorMessage('Sorry, Wine Club members must be 21 year or older')}

    }
    else {
      setStep1Complete(false);
      
    }
    // 
    
  }
  const checkStep3Completed = () => {
    // check if step one birthday
    if (clubType) {
      setStep3Complete(true)
    }
    else {
      setStep3Complete(false)
    }
    // 
  }

  useEffect(() => {
    let day = new Date(`${birthDateMonth}/${birthDateDay}/${birthDateYear}`);
    let formatTime = (day.getMonth() + 1) + "/" + (day.getDate()) + "/" + day.getFullYear();
    setFormattedTime(formatTime);

    checkStep1Completed()
  }, [birthDateMonth, birthDateDay, birthDateYear])

  useEffect(() => {
    activeStep === 1 && setActiveStepFormHeading('Recipient Details')
    activeStep === 2 && setActiveStepFormHeading('Pickup Location')
    activeStep === 3 && setActiveStepFormHeading('Club Details')
    activeStep === 4 && setActiveStepFormHeading('Create Account')
    activeStep === 5 && setActiveStepFormHeading('Review & Pay')
  }, [activeStep])


  useEffect(() => {

    const headers = { 'Content-Type': 'application/json' }
    fetch(`https://stageolo.chwinery.com/api/olo/restaurants/near?lat=${initLat}&long=${initLng}&radius=${mapRadius}&limit=30&includePrivate=true`, { headers })
      .then(res => res.json())
      .then(data => {
        // automatically set the closest restaurant location to the user's geolation as their selected location only if the user-selected location(name,state and city) 'react usestate values' are in their initialstate  
        if (
          locationSelectedName === 'Location'
          &&
          locationSelectedAddress === 'Location Address'
          &&
          locationSelectedCity === 'Location City'
        ) {
          setRestaurants(data.restaurants);
          setLocationSelectedName(data.restaurants[0].name);
          setLocationSelectedAddress(data.restaurants[0].streetaddress);
          setLocationSelectedCity(data.restaurants[0].city);
        }
      })
      .catch(error => console.error(error))
  }, [initLat, initLng, mapRadius])

  useEffect(() => {
    const headers = { 'Content-Type': 'application/json' }
    fetch(`https://stageolo.chwinery.com/api/olo/restaurants/near?lat=${typedLat}&long=${typedLng}&radius=${mapRadius}&limit=30`, { headers })
      .then(res => res.json())
      .then(data => {
        setRestaurants(data.restaurants);
      })
      .catch(error => console.error(error))

  }, [typedLng, typedLat, mapRadius])







  //  ###  schemas
  let userPasswordValid;
  let emailAddressValid;

  const emailAddressSchema = yup.object().shape({
    emailAddress: yup.string().email().required(),
  })
  const userPasswordSchema = yup.object().shape({
    // userPassword: yup.string().min(4).max(10).required(),
    userPassword: yup.string().required('Please Enter your password')
    .matches(/^(?=.*[a-z])(?=.*[A-Z])/,
      "Must Contain One Uppercase, One Lowercase, "
    ),
  })


  const step4Validate = async (e) => {
    // e.preventDefault();
    let formData = {
      emailAddress: emailAddress,
      userPassword: userPassword
    }
    const userPasswordValid = await userPasswordSchema.isValid(formData);
    const emailAddressValid = await emailAddressSchema.isValid(formData);

    console.log('emailAddressValid:', emailAddressValid)
    emailAddressValid &&setEmailValid(true);
    (userPasswordValid && userPassword.length >= 7) ? setPasswordValid(true):setPasswordValid(false)
    console.log('userPasswordValid:', userPasswordValid)
    
  }




  return (
    <>
      {!isSignupCompleted && <> <StyledJoinClubHeader>
        <br />
        <h2 className="header-text">Join the club</h2>
        <div className="stepped-progress-bar">
          <div className="stepped-item-container active-border">
            <div
              className={
                activeStep >= 1 && activeStep <= 3
                  ? "stepped-item-3 active-color"
                  : "stepped-item-3"}>Customize&nbsp;Membership
            </div>
            <div className="item-bar"></div>
          </div>
          {/* bar 2 */}
          <div
            className={
              activeStep >= 4
                ? "stepped-item-container active-border"
                : "stepped-item-container grey-border"
            }>
            <div
              className={
                activeStep === 4
                  ? "stepped-item-2 active-color"
                  : "stepped-item-2"}>Contact Info
            </div>
            <div className="item-bar"></div>
          </div>
          <div
            className={
              activeStep >= 5
                ? "stepped-item-container active-border"
                : "stepped-item-container grey-border"
            }>
            <div
              className={
                activeStep === 5 || activeStep === 6
                  ? "stepped-item-3 active-color"
                  : "stepped-item-3"}>Payment
            </div>
            <div className="item-bar"></div>
          </div>
        </div>
      </StyledJoinClubHeader>
        {/* Which StepProgressSection are we in and what step inside that */}
        {/* 
 activeStep is a state variable which steps 1 to 6. forwards and backwards.
 controlling the header titles and input elements being rendered.
 */}
        <StyledFormStep>
          <div className="formstep-section-title">
            <div className="formstep-section-back-container">

              {activeStep <= 3 && <p>Customize&nbsp;Membership {activeStep} of {3}</p>}
              {activeStep === 4 && <p>Contact Info {activeStep - 3} of {1}</p>}
              {activeStep >= 5 && <p>Payment {activeStep - 4} of {2}</p>}
            </div>
            <h3 onClick={() => { setAltBack(true) }}>{activeStepFormHeading}</h3>

          </div>
          <div className="form-wrap">

            <form onSubmit={step4Validate} className="validation-form floating-labels">
              {/*  */}
              {/* Customize Membership 1 of 3 */}
              {/* 
  __                 ___   ________              ______   
 /  |              .'   `.|_   __  |            / ____ `. 
 `| |             /  .-.  \ | |_ \_|            `'  __) | 
  | |             | |   | | |  _|               _  |__ '. 
 _| |_            \  `-'  /_| |_                | \____) | 
|_____|            `.___.'|_____|               \______.' 
                                                                                       
*/}
              {activeStep === 1 &&
                <>
                  <br />
                  <div className="input-group" style={{ marginTop: '-2.75em', userSelect: 'none' }}>
                    <StyledSelect>
                      <div className="inputGroup" style={{ paddingTop: '2em', marginTop: '-2.75em' }}>
                        <input checked={monthlyMembership ? true : false}
                          onClick={() => { setMonthlyMembership(true); setGiftMembership(false) }} 
                          id="radio1" name="radio-member" type="radio"
                          value={monthlyMembership} />
                        <label for="radio1" style={{ paddingLeft: '4em' }}>Myself</label>
                      </div>
                      <div className="inputGroup">
                        <input
                          checked={giftMembership ? true : false}
                          onClick={() => { setGiftMembership(true); setMonthlyMembership(false) }} id="radio2" name="radio-member" type="radio" value={giftMembership} />
                        <label for="radio2" style={{ paddingLeft: '4em' }}>Someone Else</label>
                      </div>
                    </StyledSelect>
                   
                    <label htmlFor="membershipFor"><span id="float-label-membership" className="float-label">Who is this membership for?</span></label>
                  </div>
                  <div className="input-group">
                    <label htmlFor="birthDate"><span className="float-label">Birthdate of recipient</span></label>

                    <p style={{ fontWeight: 'bold', color: '#777', fontSize: '0.98em', transform: 'translate3d(0,0.5em,0)' }}>MM / DD / YYYY</p>
                  
                  </div>
                  <div style={{ display: 'flex', marginTop: '4vh', gap: '1.25em' }}>
                    <input minLength="2" maxLength="2" className={birthDateMonth.length === 1 ? "input-holder invalid-red" : "input-holder"} name="birthDateMonth" value={birthDateMonth} type="text" onChange={(e) => {
                      setBirthDateMonth(e.target.value);
                      let monthRegex = /[a-z]/i;
                      if (e.target.value.match(monthRegex)) {
                        setBirthDateMonth('')
                        // alert("Must input numbers");
                        
                      }

                    }} />
                    <input minLength="2" maxlength="2" className={birthDateDay.length === 1 ? "input-holder invalid-red" : "input-holder"} name="birthDateDay" value={birthDateDay} type="text" onChange={(e) => {
                      setBirthDateDay(e.target.value);
                      let dayRegex = /[a-z]/i;
                      if (e.target.value.match(dayRegex)) {
                        setBirthDateDay('')
                        // alert("Must input numbers");
                      
                      }
                    }} />

                    <input minlength="4" maxlength="4" className="input-holder" name="birthDateYear" value={birthDateYear} type="text" onChange={(e) => {
                      setBirthDateYear(e.target.value);
                      let yearRegex = /[a-z]/i;
                      if (e.target.value.match(yearRegex)) {
                        setBirthDateYear('')
                        
                        // alert("Must input numbers");
                        // return false;
                      }
                    }} />
                  </div>
                  
<p style={{color:'#D00D00'}}>{step1ErrorMessage}</p>
                </>
              }

              {/*  */}
              {/* Customize Membership 2 of 3 */}
              {/*  
  _____                ___   ________              ______   
 / ___ `.            .'   `.|_   __  |            / ____ `. 
|_/___) |           /  .-.  \ | |_ \_|            `'  __) | 
 .'____.'           | |   | | |  _|               _  |__ '. 
/ /_____            \  `-'  /_| |_               | \____) | 
|_______|            `.___.'|_____|               \______.'  
            
*/}

              {activeStep === 2 &&
                <>
                  <div className="input-group" style={{ marginTop: '-2.5em', userSelect: 'none' }}>
                    <input type="text" id="zipCode" value={zipCode} onChange={(e) => { setZipCode(e.target.value) }} name="zipCode" maxLength="5" required />
                    <label htmlFor="zipCode"><span className="float-label">Zip code</span></label>
                  </div>

                  {/*  */}
                  <div className="select-group" style={{ marginTop: '3.5em' }}>
                    <select defaultValue="100" required onChange={(e) => { setMapRadius(e.target.value) }}>
                      <option value=""
                        hidden
                      >Radius</option>

                      {/* <!-- normal options --> */}
                      <option value="5">5 Miles</option>
                      <option value="10">10 Miles</option>
                      <option value="15">15 Miles</option>
                      <option value="50">50 Miles</option>
                      <option value="500">500 Miles</option>
                    </select>
                    <label htmlFor="radius" style={{ transform: 'translate3d(0.67em ,-1.35em,0)', zIndex: '0' }}><span className="float-label">Radius</span></label>
                  </div>

                  <div className="map-card">
                    <div className="map-selections-holder">
                      <div>
                        <Map
                          restaurants={restaurants}
                          zipCode={zipCode}
                          typedLat={typedLat}
                          typedLng={typedLng}
                          setTypedLat={setTypedLat}
                          setTypedLng={setTypedLng}
                          selectedLat={selectedLat}
                          setSelectedLat={setSelectedLat}
                          selectedLng={selectedLng}
                          setSelectedLng={setSelectedLng}
                          initLat={initLat}
                          setInitLng={setInitLng}
                         
                        />
                        {!initLat && <p>loading map...</p>}

                        <h6 id="item-title">Select primary pickup location</h6>
                      </div>
                      <div className="card-selections">
                        {/* filter based on zip code */}
                        {initLat !== undefined && restaurants.map((location, index) =>
                        (<>

                          <ItemCard onClick={() => { setIsLocationSelected(index); setLocationSelectedName(location.name); setLocationSelectedAddress(location.streetaddress); setLocationSelectedCity(location.city);setSelectedLat(location.latitude);setSelectedLng(location.longitude); }}
                            key={`ItemCard-${index}`}
                            uid={index}
                            location={location}
                            isLocationSelected={isLocationSelected}
                          />
                        </>))}
                      </div>
                    </div>
                    <p className="pickup-text" style={{ textAlign: 'left', fontSize: '1em' }}>Selected primary pickup location</p>
                    <h2 style={{ color: '#222', fontFamily: "'Roboto', sans-serif", fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.01em' }}>{locationSelectedName}</h2>
                    <p style={{ textAlign: 'left', fontSize: '1em' }}>{locationSelectedAddress}</p>
                    <p style={{ textAlign: 'left', fontSize: '1em' }}>{locationSelectedCity}</p>

                  </div>
                  <p onClick={() => { setIsDelivery(true); handleNextStep() }} style={{ textAlign: 'center', color: '#9c7456', padding: '5px 7px', cursor: 'pointer', position: 'relative', zIndex: '9999' }}>Prefer to have your wine delivered?</p>

                </>
              }

              {/*  */}
              {/* Customize Membership 3 of 3 */}
              {/*
  ______                ___   ________              ______   
 / ____ `.            .'   `.|_   __  |            / ____ `. 
 `'  __) |           /  .-.  \ | |_ \_|            `'  __) | 
 _  |__ '.           | |   | | |  _|               _  |__ '. 
| \____) |           \  `-'  /_| |_                | \____) | 
 \______.'            `.___.'|_____|                \______.'  
             
 */}

              {activeStep === 3 &&
                <>

                  {/* <input type="text" id="clubtype" value={inputs.name} onChange={handleChange} name="clubtype" required />
 <label htmlFor="clubtype"><span className="float-label">Club Type</span></label> */}
                  <div className="select-group" style={{ marginTop: '-2.5em' }}>
                    {/* <label htmlFor="clubType"><span className="float-label">Club type</span></label> */}
                    <select required onChange={(e) => { setClubType(e.target.value); 
                      monthlyMembership && setStep3Complete(true) }}>
                      <option hidden
                      >Club type</option>

                      {/* <!-- normal options --> */}
                      <option value="variety">Variety wine club</option>
                      <option value="red">Red wine club </option>
                      <option value="white">White wine club </option>
                      <option value="sweet">Sweet wine club</option>
                      {/* <option value="5">Option 5</option> */}
                    </select>
                    <label htmlFor="clubType" style={{ transform: 'translate3d(0.67em ,-1.5em,0)', zIndex: '0' }}><span className="float-label">Select club type</span></label>
                  </div>
                  <br />
                  <br />
                  {giftMembership && <div className="select-group">
                    {/* <label htmlFor="clubType"><span className="float-label">Club type</span></label> */}
                    <select required onChange={(e) => { setSubscriptionLength(e.target.value);
                    (giftMembership&&clubType!=='')&&setStep3Complete(true) }}>
                      <option value=""
                        hidden
                      >Subscription length</option>

                      {/* <!-- normal options --> */}
                      <option value="3">3 Months</option>
                      <option value="6">6 Months</option>
                      <option value="12">12 Months</option>
                    </select>
                    <label htmlFor="clubType" style={{ transform: 'translate3d(0.67em ,-1.35em,0)', zIndex: '0' }}><span className="float-label">Subscription length</span></label>
                  </div>}
                  {/* <div className="input-group">
 <input type="text" id="subscription-length" value={inputs.name} onChange={handleChange} name="subscription-length" required />
 <label htmlFor="subscription_length"><span className="float-label">Subscription length</span></label>
 </div> */}
                  <br />
                  <StyledBottleNumSelect>
                    <h4 className="bottle-num-title">Number of bottles per month</h4>
                    <div className="bottle-num-select">
                      <div
                        onClick={() => { setSelectBottleLvl(1) }} className={selectBottleLvl === 1 ? "bottle-card bottle-card-active" : "bottle-card"}>
                        <img src="https://dl3.pushbulletusercontent.com/LcUdqXtIYHiXGxnESDbTYr0NEGwNBuKL/image%202.png" alt="" className="bottle-card-img" />
                        <div className={selectBottleLvl === 1 ? "bottle-card-footer-box footer-box-active" : "bottle-card-footer-box"}>
                          <h4
                            className={selectBottleLvl === 1 ? "bottle-card-footer-text footer-text-active" : "bottle-card-footer-text"}>1 Bottle</h4>
                        </div>
                      </div>
                      <div onClick={() => { setSelectBottleLvl(2) }} className={selectBottleLvl === 2 ? "bottle-card bottle-card-active" : "bottle-card"}>
                        <img style={{ borderRadius: '8px' }} src="https://dl3.pushbulletusercontent.com/i7MAiKOJ6D7QwpcnYpnQMrrpnZHYN9Q6/image.png" alt="" className="bottle-card-img" />
                        <div className={selectBottleLvl === 2 ? "bottle-card-footer-box footer-box-active" : "bottle-card-footer-box"}>
                          <h4
                            className={selectBottleLvl === 2 ? "bottle-card-footer-text footer-text-active" : "bottle-card-footer-text"}>2 Bottle</h4>
                        </div>
                      </div>
                      <div onClick={() => { setSelectBottleLvl(3) }} className={selectBottleLvl === 3 ? "bottle-card bottle-card-active" : "bottle-card"}>
                        <img style={{ borderRadius: '8px' }} src="https://dl3.pushbulletusercontent.com/GPwitwfxV1fcLNk8WXPHcz3XLivvYR6m/image.png" alt="" className="bottle-card-img" />
                        <div className={selectBottleLvl === 3 ? "bottle-card-footer-box footer-box-active" : "bottle-card-footer-box"}>
                          <h4
                            className={selectBottleLvl === 3 ? "bottle-card-footer-text footer-text-active" : "bottle-card-footer-text"}>3 Bottle</h4>
                        </div>
                      </div>
                    </div>
                  </StyledBottleNumSelect>
                </>
              }

              {/* Contact Info 1 of 1 */}
              {/* 
  __                 ___   ________              __    
 /  |              .'   `.|_   __  |            /  |   
 `| |             /  .-.  \ | |_ \_|            `| |   
  | |             | |   | | |  _|                | |   
 _| |_            \  `-'  /_| |_                _| |_  
|_____|            `.___.'|_____|              |_____|  */}
              {activeStep === 4 &&
                <>
                  <div className="input-group" style={{ marginTop: '-2.05em' }}>
                    <input type="email" id="email" value={emailAddress}
                      onChange={(e) => {setEmailAddress(e.target.value);step4Validate()}} name="email" required />
                    <label htmlFor="email"><span className="float-label">Email address</span></label>
                  </div>

                  <div className="input-group">
                    <div className="password-show" onClick={()=>{setPasswordShow(!passwordShow)}}><i className={passwordShow?"fa fa-eye-slash":"fa fa-eye"} ></i></div>
                    <input type={passwordShow ? "text":"password"} id="password" value={userPassword} 
                    onChange={(e) => { setUserPassword(e.target.value);}} 
                    onBlur={()=>step4Validate()}
                    name="password"
                    // className={}
                    required 
                    />
                    <label htmlFor="password"><span className="float-label">Password</span></label>
                  </div>
                  <ul className={ passwordValid ? "error-handle-container" : "error-handle-container invalid-red-text"}>
                    <li>Password Must Contain At Least 8 Characters</li>
                    <li>At Least One Uppercase Letter</li>
                    <li>At Least One Lowercase Letter</li>
                  </ul>

                  <h3 style={{ padding: '0.35em 0 0.67em 0', fontSize: '1.88em', fontFamily: "'Bebas Neue',cursive", textAlign: 'center' }}>Personal Details</h3>
                  {/* gift member intake */}
                  {giftMembership && <>
                    <div className="input-group">
                      <input type="text" id="recipFirstName" value={recipFirstName} onChange={(e) => { setRecipFirstName(e.target.value) }} name="recipFirstName" required />
                      <label htmlFor="recipFirstName"><span className="float-label">Recipient's first name</span></label>
                    </div>
                    <div className="input-group">
                      <input type="text" id="recipLastName" value={recipLastName} onChange={(e) => { setRecipLastName(e.target.value) }} name="recipLastName" required />
                      <label htmlFor="recipLastName"><span className="float-label">Recipient's last name</span></label>
                    </div>
                    <div className="input-group">
                      <input type="text" id="recipEmail" value={recipEmail} onChange={(e) => { setRecipEmail(e.target.value) }} name="recipEmail" required />
                      <label htmlFor="recipEmail"><span className="float-label">Recipient's email for notification</span></label>
                    </div>

                    <br />

                    <div className="input-group">
                      <label for="recipMessage"><p style={{ marginTop: '-1em' }}>Message for recipient</p></label>

                      <textarea style={{ border: '2px solid #8C683C', borderRadius: '8px' }} id="recipMessage" value={recipMessage} onChange={(e) => { setRecipMessage(e.target.value) }} name="recipMessage"
                        rows="5" cols="33">
                        Insert your custom message here...
                      </textarea>
                    </div></>
                  }
                  {/* monthly member intake */}
                  {monthlyMembership && <>
                    <div className="input-group">
                      <input type="text" id="firstName" value={firstName} onChange={(e) => { setFirstName(e.target.value) }} name="firstName" required />
                      <label htmlFor="firstName"><span className="float-label">First name</span></label>
                    </div>
                    <div className="input-group">
                      <input type="text" id="lastName" value={lastName} onChange={(e) => { setLastName(e.target.value) }} name="lastName" required />
                      <label htmlFor="lastName"><span className="float-label">Last name</span></label>
                    </div>
                    <div className="input-group">
                      <input type="tel" id="phoneNumber" value={phoneNumber} onChange={(e) => { setPhoneNumber(e.target.value) }} name="phoneNumber" required />
                      <label htmlFor="phoneNumber"><span className="float-label">Phone Number</span></label>
                    </div>
                    {isDelivery && <> <div className="input-group">

                      <label htmlFor="Delivery Address"><span className="float-label">Deliver to Address </span></label>
                    </div>

                      {/* <p>lat: {coordinates.lat}</p>
                    <p>lng: {coordinates.lng}</p>
                    <p>addy: {address}</p> */}
                      <PlacesAutocomplete
                        value={address}
                        onChange={setAddress}
                        onSelect={handleSelect}
                      >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <div>
                            <input
                              {...getInputProps({
                                placeholder: ' ',
                                className: 'location-search-input',
                              })}
                            />
                            <div className="autocomplete-dropdown-container">
                              {loading && <div>Loading...</div>}
                              {suggestions.map(suggestion => {
                                const className = suggestion.active
                                  ? 'suggestion-item--active'
                                  : 'suggestion-item';
                                // inline style for demonstration purpose
                                const style = suggestion.active
                                  ? { backgroundColor: '#efefff', cursor: 'pointer', border: '1px solid #ccc', padding: '5px 7px', }
                                  : { backgroundColor: '#ffffff', cursor: 'pointer', border: '1px solid #ccc', padding: '5px 7px' };
                                return (
                                  <div
                                    {...getSuggestionItemProps(suggestion, {
                                      className,
                                      style,
                                    })}
                                  >
                                    <span>{suggestion.description}</span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                      <br />
                      <br />
                    </>
                    }
                    {/* <button type="submit">SUBMITT</button> */}
                    <br />
                  </>
                  }
                </>}

              {/* Payment 1 of 1 */}
              {/* 
  __                 ___   ________              __    
 /  |              .'   `.|_   __  |            /  |   
 `| |             /  .-.  \ | |_ \_|            `| |   
  | |             | |   | | |  _|                | |   
 _| |_            \  `-'  /_| |_                _| |_  
|_____|            `.___.'|_____|              |_____| 
 */}

              {activeStep === 5 &&
                <>
                  <h3 style={{ marginTop: '-1.45em', fontSize: '1.08em', paddingBottom: '1.05em', fontFamily: "'Bebas Neue',cursive", textAlign: 'left' }}>Payment</h3>
                  <br />

                  <br />
                  {
                    (activeStep === 5 && userInfoSavingSFLoading)
                      ?
                      <LoadingSpinner />
                      :
                      <StyledDetailsReview>
                        <li>Recipient: <span className="review-detail-item">{giftMembership ? 'Gift' : 'Member'}</span></li>
                        <li>Birth date: <span className="review-detail-item">
                          {/* {inputs.birthDate} */}
                          {formattedTime}
                        </span></li>
                        <li>Pickup location: <span className="review-detail-item">{locationSelectedName}</span></li>
                        <li style={{ display: 'flex' }}>Club type: <li id="review-club-type" className="review-detail-item">&nbsp;{clubType}</li></li>
                        {giftMembership && <li>Subscription length: <span className="review-detail-item">{subscriptionLength} months</span></li>}
                        <li>Number Of bottles: <span className="review-detail-item"> {selectBottleLvl} {selectBottleLvl > 1 ? 'bottles' : 'bottle'}</span></li>

                        <hr style={{ border: '1px solid #888', width: '100%' }} />
                        <div style={{ height: '0.3em' }}></div>
                        <li>Total Monthly Cost: <span style={{ paddingLeft: '17vw' }} className="review-detail-item">$21.99 / month</span></li>

                        <h5 className="edit-details">Edit Membership Details</h5>
                        {blueFormLoading
                          ?
                          <DotsLoadingSpinner />
                          :
                          <iframe
                            src={`${bluepayUrl}&enhancedresponse=true&cardnumbernumericonly=true&invalidcreditcardevent=true&invalidcvvevent=true&invalidexpiryevent=true`}
                            style={{ height: '200vh', maxWidth: '88vw', border: '0', overflowY: 'scroll' }}
                            // ref={bluepayRef}
                            scrolling="no"
                          ></iframe>

                        }
                      </StyledDetailsReview>
                  }




                  <button className="btn btn-primary" onClick={(e) => {
                    e.preventDefault(); window.scrollTo({
                      top: 0,
                      left: 100,
                      behavior: 'smooth'
                    }); setIsSignupCompleted(true); setPaymentSuccess(true)
                  }} style={{ position: 'relative', left: '50%', transform: 'translate3d(-50%,0,0)', background: '#222' }}>Go to Success</button>
                  {/* fail button */}
                  <button className="btn btn-primary" onClick={(e) => {
                    e.preventDefault(); window.scrollTo({
                      top: 0,
                      left: 100,
                      behavior: 'smooth'
                    }); setIsSignupCompleted(true); setPaymentSuccess(false)
                  }} style={{ position: 'relative', left: '50%', transform: 'translate3d(-50%,0,0)', background: '#222' }}>Go to fail payment</button>
                </>}
              {/* if activestep is 5 then 'review' & is 6 then '? :' submit */}
              <br />
              <div className="btn-footer">
                {/* if step is above */}

                <button id="next-button" className="btn btn-primary" onClick={(e) => {

                  e.preventDefault(); window.scrollTo({
                    top: 0,
                    left: 100,
                    behavior: 'smooth'
                  });

                  if ((activeStep === 1 && step1Complete) || activeStep === 2) { handleNextStep() }
                  if ((activeStep === 3 && step3Complete)) { handleNextStep() }
                  if((activeStep === 4 && (passwordValid && emailValid && step4Complete))){handleNextStep()}

                  // handleNextStep()
                }}>Next</button>
                {/* */}
                {activeStep > 1 &&
                  <button className="back-link" onClick={(e) => {
                    e.preventDefault(); window.scrollTo({
                      top: 0,
                      left: 100,
                      behavior: 'smooth'
                    }); handleBackStep()
                  }}>Back</button>
                }
              </div>
            </form>

          </div>
        </StyledFormStep>
      </>
      }
      {/* signup completed PAYMENT SUCCESS */}
      {(isSignupCompleted && paymentSuccess) && <VideoWelcome />
      }
      {/* signup completed && PAYMENT FAIL */}
      {(isSignupCompleted && !paymentSuccess) && <PayFailWelcome />
      }

      {/* 
 <ul>
 <li>{inputs.membershipFor}</li>
 <li>{inputs.birthDate}</li>
 <li>{inputs.radius}</li>
 <li>{inputs.clubtype}</li>
 <li>{inputs.subscription_length}</li>
 <li>{inputs.email}</li>
 <li>{inputs.password}</li>
 <li>{inputs.recipFirstName}</li>
 <li>{inputs.recipLastName}</li>
 <li>{inputs.recipEmail}</li>
 <li>{inputs.recipMessage}</li>
 <li>{inputs.firstName}</li>
 <li>{inputs.lastName}</li>
 <li>{inputs.tel}</li>
 </ul> */}


    </>
  )
}


export default JoinClubHeader